import { gql } from '@apollo/client';

export const CreateNotification = gql`
  mutation CreateNotification($input: CreateNotificationInput!) {
    createNotification(input: $input) {
      _id
      title
      message
      active
      membership
      date
    }
  }
`;

export const UpdateNotification = gql`
  mutation UpdateNotification($input: UpdateNotificationInput!) {
    updateNotification(input: $input)
  }
`;

export const DeleteNotification = gql`
  mutation DeleteNotification($id: ObjectId!) {
    deleteNotification(notificationId: $id)
  }
`;

export const GeNotificationById = gql`
  mutation GetNotificationById($notifactionId: ObjectId!) {
    getNotificationById(notifactionId: $notifactionId) {
      _id
      membership
      active
      date
      message
      title
    }
  }
`;

export const CreateScheduledNotification = gql`
  mutation CreateScheduledNotification(
    $input: CreateScheduledNotificationInput!
  ) {
    createScheduledNotification(input: $input) {
      _id
      title
      message
      active
      membership
      date
      days
    }
  }
`;

export const UpdateScheduledNotification = gql`
  mutation UpdateScheduledNotification(
    $input: UpdateScheduledNotificationInput!
  ) {
    updateScheduledNotification(input: $input)
  }
`;

export const DeleteScheduledNotification = gql`
  mutation DeleteScheduledNotification($id: ObjectId!) {
    deleteScheduledNotification(notificationId: $id)
  }
`;

export const GeScheduledNotificationById = gql`
  mutation GetScheduledNotificationById($notifactionId: ObjectId!) {
    getScheduledNotificationById(notifactionId: $notifactionId) {
      _id
      membership
      active
      date
      message
      title
      days
    }
  }
`;
